<form [formGroup]="parecerForm" class="forms">
  <div class="row">
    <div class="row info-container white-box">
      <h2>Parecer do Agente</h2>
      <div class="form-group">
        <span class="icon parecer-agente"></span>
        <div class="inputs">
          <label for="parecerAgente">Parecer</label>
          <textarea
            class="form-control textarea"
            id="parecerAgente"
            formControlName="parecerAgente"
            rows="7"
            maxlength="500"
            appShowErrorMessages></textarea>
        </div>
      </div>
      <div class="form-group">
        <span class="icon balanca-cash"></span>
        <div class="inputs">
          <label for="notaConfiancaCliente">Nota de confiança</label>
          <select class="form-control"
            id="notaConfiancaCliente"
            formControlName="notaConfiancaCliente"
            appShowErrorMessages>
            <option value="" selected hidden>Selecione...</option>
            <option *ngFor="let nota of valoresNotaConfianca" [value]="nota">{{nota}}</option>
          </select>
        </div>
      </div>
      <div class="form-group">
        <span class="icon credito-pessoal"></span>
        <div class="inputs">
          <label for="valorEmprestaria">Quanto emprestaria?</label>
          <input
            class="form-control"
            type="text"
            placeholder="R$ 0.000,00"
            id="valorEmprestaria"
            formControlName="valorEmprestaria"
            maxlength="17"
            appShowErrorMessages
            mask-money
            inputmode="numeric"
            [prefix]="'R$'"
            appOnlyNumberRestrictive>
        </div>
      </div>
    </div>
  </div>
</form>

<app-botao-navegacao
(previous)="onClickPrevious()"
(next)="onClickNext()"
[previousShow]="true"
[nextShow]="true"
[nextEnabled]="parecerForm.valid">
</app-botao-navegacao>
